export default {
  'jobs': 'Hot jobs',
  'jobs_explanation': 'Want to join our family ? Here is the last vacant jobs... Just send us an email with your resume',
}
